import React from "react";
import { Layout, Menu, Drawer, Button } from "antd";
import { MenuOutlined } from "@ant-design/icons";
import { Link, Outlet, useLocation } from "react-router-dom";
import { routes } from "../../routes";
import { isDemoMode } from "../../config/demoConfig";
import CustomFooter from "./CustomFooter";
import DemoFooter from "./DemoFooter";
import styles from "./BaseLayout.module.css";

const { Header, Content } = Layout;

const BaseLayout: React.FC = () => {
  const location = useLocation();
  const [mobileMenuOpen, setMobileMenuOpen] = React.useState(false);

  const isHomePage = location.pathname === `${routes.HOME}`;

  const fullMenuItems = [
    { key: `${routes.HOME}`, label: <Link to={`${routes.HOME}`}>Home</Link> },
    {
      key: `${routes.PROJECT}`,
      label: <Link to={`${routes.PROJECT}`}>Il Progetto</Link>,
    },
    {
      key: `malattie`,
      label: "Malattie d'interesse",
      children: [
        {
          label: (
            <Link to={`${routes.AMILOIDOSI_CARDIACA}`}>
              Amiloidosi cardiaca
            </Link>
          ),
          key: `${routes.AMILOIDOSI_CARDIACA}`,
        },
        {
          label: (
            <Link to={`${routes.MALATTIA_DI_FABRY}`}>Malattia di Fabry</Link>
          ),
          key: `${routes.MALATTIA_DI_FABRY}`,
        },
        {
          label: (
            <Link to={`${routes.CARDIOMIOPATIA_IPERTROFICA_OSTRUTTIVA}`}>
              Cardiomiopatia ipertrofica ostruttiva
            </Link>
          ),
          key: `${routes.CARDIOMIOPATIA_IPERTROFICA_OSTRUTTIVA}`,
        },
        {
          label: (
            <Link to={`${routes.IPERCOLESTEROLEMIA_FAMILIARE}`}>
              Ipercolesterolemia familiare
            </Link>
          ),
          key: `${routes.IPERCOLESTEROLEMIA_FAMILIARE}`,
        },
      ],
    },
    {
      key: `${routes.SYMPTOMS}`,
      label: <Link to={`${routes.SYMPTOMS}`}>Segni e sintomi suggestivi</Link>,
    },
    {
      key: `${routes.CONTACT}`,
      label: <Link to={`${routes.CONTACT}`}>Contatti</Link>,
    },
    {
      key: `${routes.LOGIN}`,
      label: <Link to={`${routes.LOGIN}`}>Area Riservata</Link>,
    },
    {
      key: `${routes.REGISTER}`,
      label: <Link to={`${routes.REGISTER}`}>Registrazione Medico</Link>,
    },
    {
      key: `${routes.PATIENT_CONTACT}`,
      label: (
        <Link to={`${routes.PATIENT_CONTACT}`}>Registrazione Paziente</Link>
      ),
    },
  ];

  const demoMenuItems = [
    {
      key: `${routes.LOGIN}`,
      label: <Link to={`${routes.LOGIN}`}>Area Riservata</Link>,
    },
  ];

  const menuItems = isDemoMode ? demoMenuItems : fullMenuItems;

  return (
    <Layout className="layout">
      <Header style={{ display: "flex", alignItems: "center" }}>
        <div style={{ display: "flex", alignItems: "center", width: "100%", justifyContent: "space-between" }}>
          <div className="logo" />
          
          <Button 
            className={styles.mobileMenuBtn}
            type="text" 
            icon={<MenuOutlined style={{ color: 'white', fontSize: '20px' }} />} 
            onClick={() => setMobileMenuOpen(true)}
          />

          <Menu
            theme="dark"
            mode="horizontal"
            selectedKeys={[location.pathname]}
            items={menuItems}
            className={styles.desktopMenu}
            style={{ flex: 1, minWidth: 0, justifyContent: "flex-end" }}
          />
        </div>
      </Header>
      
      <Drawer
        title="Menu"
        placement="right"
        onClose={() => setMobileMenuOpen(false)}
        open={mobileMenuOpen}
        bodyStyle={{ padding: 0 }}
      >
        <Menu
          mode="inline"
          selectedKeys={[location.pathname]}
          items={menuItems}
          onClick={() => setMobileMenuOpen(false)}
        />
      </Drawer>
      <Content
        className={!isHomePage ? styles.contentWithPadding : styles.content}
      >
        <Outlet />
      </Content>
      {isDemoMode ? <DemoFooter /> : <CustomFooter />}
    </Layout>
  );
};

export default BaseLayout;
